<template>
  <div class="row shadow-none">
    <div class="col">
      <span v-show="false">{{ getOrders }}</span>
      <div :class="['be-loading', { 'be-loading-active': isBusy }]">
        <div class="w-full pb-2 flex flex-col justify-start items-start gap-[15px]">
          <!-- Tabs Section -->
          <div class="w-full flex justify-start items-start gap-[11px]">
            <button v-if="hasPermission('Sales_Order_View')" :class="[
              'text-[14px] font-semibold leading-[20px] cursor-pointer focus:outline-none py-[5px]',
              {
                'border-b-2 border-[#2463EB] text-[#2463EB]': activeTab === 'sales',
                'text-[#96a0b5]': activeTab !== 'sales',
              },
            ]" @click="switchTab('sales')">
              All Sales Order
            </button>
          </div>
          <div v-if="activeTab === 'sales'"
            class="flex xs:flex-col lg:flex-row xs:justify-start lg:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 lg:items-center">
            <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
              Sales Order
            </p>
            <div class="flex gap-3 flex-wrap xs:justify-start lg:justify-center xs:items-start lg:items-center">
              <button @click="viewFilter"
                class="border-[1px] border-[#96a0b5] rounded-[8px] text-[#96a0b5] font-normal text-[14px] border-solid px-[24px] py-[12px] outline-none focus:outline-none">
                <span class="feather icon-filter text-[#96a0b5]"></span> Filters
              </button>
              <button
                class="border-[1px] bg-[#7367F0] rounded-[8px] text-white font-normal border-solid text-[12px] sm:text-[14px] border-solid px-[12px] sm:px-[24px] py-[12px] flex items-center gap-[5px] outline-none focus:outline-none"
                @click="downloadAll">
                <span v-if="exportAllLoading">
                  Loading..
                </span>
                <span v-else class="flex items-center gap-[5px]">
                  <span><img src="/assets/icon/export.svg" alt="" /></span>
                  Export
                </span>
              </button>
            </div>
          </div>
          <div v-if="activeTab === 'order'"
            class="flex xs:flex-col lg:flex-row xs:justify-start lg:justify-between w-full xs:items-start xs:gap-4 lg-gap-2 lg:items-center">
            <p class="text-[#353535] text-[14px] leading-[20px] font-semibold">
              Sales Order Status
            </p>
          </div>
        </div>
        <div v-if="activeTab === 'sales'">
          <div class="table-responsive relative">
            <table class="table p-0 m-0 dataTable no-footer min-h-[185px] text-nowrap">
              <thead class="bg-white">
                <tr class="py-[5px]">
                  <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Distributor Name</th>
                  <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">PO Number</th>
                  <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Order Amount</th>
                  <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">SAP Number</th>
                  <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Submitted Date</th>
                  <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Approval Date</th>
                  <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Status</th>
                  <th class="text-[12px] leading-[18px] text-[#000000] font-semibold">Actions</th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr v-if="loading">
                  <td colspan="12" class="text-center">
                    <div class="text-center" style="padding-top: 100px; padding-bottom: 50px">
                      <span class="fa-solid fa-spinner fa-spin text-[#2463EB]" style="font-size: 8rem"></span>
                      <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                        style="padding-bottom: 100px">
                        Please wait while we loading the sales orders
                      </h3>
                    </div>
                  </td>
                </tr>
                <tr v-for="o in purchaseOrders.purchaseOrders" :key="o.id" v-else>
                  <td class="text-[14px] font-normal leading-[16.94px]">{{ o.distributorName }}</td>
                  <td class="text-[14px] font-normal leading-[16.94px]">{{ o.orderNumber }}</td>
                  <Amount class="text-[14px] font-normal leading-[16.94px]" :details="o.details"
                    :discountAmount="o.discountAmount" :amount="getTotal(o.details)" />
                  <td class="text-[14px] font-normal leading-[16.94px]">{{ getSapInfo(o) }}</td>
                  <td class="text-[14px] font-normal leading-[16.94px]">{{ formatDate(o.submittedAt) }}</td>
                  <td class="text-[14px] font-normal leading-[16.94px]">
                    {{ formatDate(o.approvedAt) ? formatDate(o.approvedAt) : "***" }}
                  </td>
                  <td>
                    <span class="flex items-center gap-[4px] max-w-max w-full" :class="[
                      'badge',
                      {
                        'badge-success': getStatus(o.status) === 'approved',
                        'badge-secondary': getStatus(o.status) === 'closed',
                        'badge-warning': getStatus(o.status) === 'submitted',
                        'badge-danger': getStatus(o.status) === 'rejected',
                      },
                    ]">
                      <span class="w-[10px] h-[10px] rounded-[1px]" :style="{
                        backgroundColor:
                          getStatus(o.status) === 'approved'
                            ? '#16a249'
                            : getStatus(o.status) === 'submitted'
                              ? '#FFA500'
                              : getStatus(o.status) === 'closed'
                                ? '#ccc'
                                : '#e42728',
                      }"></span>
                      <span class="text-[12px] font-normal leading-[16.94px]">
                        {{
                          getStatus(o.status) === "approved"
                            ? "Approved"
                            : getStatus(o.status) === "closed"
                              ? "Completed"
                              : getStatus(o.status) === "submitted"
                                ? "Submitted"
                                : getStatus(o.status) === "rejected"
                                  ? "Rejected"
                                  : getStatus(o.status)
                        }}
                      </span>
                    </span>
                  </td>
                  <td @click="toggleDropdown(o.id)">
                    <div class="dropdown">
                      <button class="btn-no-border" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <span
                          class="text-[#98a2b3] dropdown text-2xl cursor-pointer relative outline-none active:outline-none shadow-none">
                          ...
                        </span>
                      </button>
                      <ul class="dropdown-menu shadow-none" aria-labelledby="dropdownMenuButton">
                        <li v-for="(action, index) in visibleActions(o)" :key="index" :class="{
                          'text-[14px] font-normal leading-[14px] text-[#353535] cursor-pointer py-[12px] px-[16px]': true,
                          'border-b border-[#e5e7eb]': index !== visibleActions(o).length - 1,
                        }" @click="action.onClick">
                          {{ action.label }}
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                <tr v-if="!purchaseOrders.purchaseOrders.length && !loading">
                  <td colspan="12">
                    <div class="text-center" style="padding-top: 50px">
                      <span style="font-size: 4.615rem" class="fa-solid fa-money text-[#2463EB]"></span>
                    </div>
                    <h3 class="text-center pt-[24px] text-[16px] font-medium leading-[16.94px]"
                      style="padding-bottom: 100px">
                      No Sales order found
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <Pagination :limit="purchaseOrders.pageSize" :count="purchaseOrders.pageCount"
            :page="purchaseOrders.pageNumber" :itemsCount="purchaseOrders.count" @changePage="gotoPage"
            @changeLimit="changeLimit" />
        </div>
        <div v-if="activeTab === 'order'">
          <StageOrder />
        </div>
      </div>

      <!-- Modal Popup -->
      <div v-if="isModalVisible" class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
        id="popup-content" @click.self="closeModal">
        <div class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto">
          <div class="flex items-center justify-between">
            <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
              {{ PurchaseOrderType == "edit" ? "Editing Sales Order" : "Viewing Sales Order" }}
            </p>
            <button class="text-2xl text-[#353535] cursor-pointer outline-none focus:outline-none" type="button"
              @click="closeModal">
              <span class="mdi text-xl mdi-close"></span>
            </button>
          </div>
          <div class="bg-white p-1 rounded-[4px] flex items-center gap-[16px] mt-[16px]">
            <button class="outline-none focus:outline-none" :class="[
              'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px]',
              {
                'bg-[#2463EB] text-white': activeSubTab === 'salesOrder',
                'bg-[#f8f8f8] text-[#96a0b5]': activeSubTab !== 'salesOrder',
              },
            ]" @click="switchSubTab('salesOrder')">
              Sales Order
            </button>
            <div>
              <button class="outline-none focus:outline-none" :class="[
                'text-[14px] font-normal py-[6px] px-[24px] rounded-[8px]',
                {
                  'bg-[#2463EB] text-white': activeSubTab === 'activeLog',
                  'bg-[#f8f8f8] text-[#96a0b5]': activeSubTab !== 'activeLog',
                },
              ]" @click="switchSubTab('activeLog')">
                Activity Log
              </button>
            </div>
          </div>
          <div v-if="activeSubTab === 'salesOrder'">
            <ViewPurchaseOrder :type="PurchaseOrderType" :purchaseId="selectedPurchaseOrder.id" :closeModal="closeModal"
              :balance="balance" :toggleEditMode="toggleEditMode" :PurchaseOrder="PurchaseOrder" />
          </div>
          <div v-if="activeSubTab === 'activeLog'">
            <ActivityLog :purchaseId="selectedPurchaseOrder.id" />
          </div>
        </div>
      </div>
    </div>
    <ProcessModal :order="order" @onComplete="onComplete" />
    <FilterPurchaseOrder @onFilter="onFilterHandler" @onClear="onFilterHandler" :isBusyModal="isBusyModal" />
    <div class="modal bg-[rgba(0, 0, 0, 0.5)] fade py-1 z-[11111111]" id="mod-update-status" role="dialog">
      <div class="modal-dialog mx-auto">
        <div class="modal-content p-[24px] bg-[#f8f8f8]">
          <div class="modal-header flex items-start justify-between p-0 m-0">
            <h4 class="font-semibold text-[20px] leading-[24px] capitalize text-[#353535] pb-[16px]">
              Update Sales Order Status
            </h4>
            <button class="text-2xl text-[#353535]" type="button" data-dismiss="modal" aria-hidden="true">
              <span class="mdi mdi-close"></span>
            </button>
          </div>
          <div class="modal-body m-0 p-0">
            <div class="mb-[16px]">
              <label class="text=[#353535] font-bold-500 text-[14px] leading-[20px]">Update Status</label>
              <div>
                <select name="" id=""
                  class="bg-transparent border-[#d0d5dd] border-solid border-[1.5px] p-[14px] rounded-[8px] w-full outline-none focus:outline-none">
                  <option value="">Select Status</option>
                  <option value="">Pending</option>
                  <option value="">Serviced</option>
                  <option value="">Dispatched</option>
                </select>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-[8px] mt-[16px]">
            <button
              class="border-[##96a0b5] border-solid border-[1.5px] py-[16px] px-[24px] rounded-[8px] text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" data-dismiss="modal">
              Cancel
            </button>
            <button
              class="bg-[#2463eb] border-[##2463eb] border-solid border py-[16px] px-[24px] rounded-[8px] text-white text-[16px] font-medium leading-[20px] w-full outline-none focus:outline-none"
              type="button" :disabled="isBusyModal" @click.prevent="create">
              <span v-if="isBusyModal">Busy...</span>
              <span v-else>Update</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ApproveModal :orderId="selectedPurchaseOrder.id" :purchaseOrder="PurchaseOrder" :closeModal="closeModal" />
    <RejectOrderItem :orderId="selectedPurchaseOrder.id" :purchaseOrder="PurchaseOrder" :closeModal="closeModal" />
  </div>
</template>

<script>
import moment from "moment";
import RejectOrderItem from "../../components/SettingsPurchaseOrder/RejectOrderItem.vue";
import Amount from "../../components/SettingsPurchaseOrder/Amount";
import ApproveModal from "../../components/SettingsPurchaseOrder/ApproveModal.vue";
import ProcessModal from "../../components/SettingsPurchaseOrder/ProcessModal";
import FilterPurchaseOrder from "../../components/SettingsPurchaseOrder/FilterPurchaseOrder.vue";
import PurchaseOrderCheckBox from "../../components/SettingsPurchaseOrder/PurchaseOrderCheckBox.vue";
import ViewPurchaseOrder from "../../components/SettingsPurchaseOrder/ViewPurchaseOrder.vue";
import { mapActions, mapGetters } from "vuex";
import SystemPermissions from "@/permissions";
import Pagination from "../../components/Pagination.vue";
import StageOrder from "../../components/SettingsPurchaseOrder/StageOrder.vue";
import ActivityLog from "../../components/SettingsPurchaseOrder/ActivityLog.vue";

export default {
  mixins: [SystemPermissions.Mixin],
  components: {
    Amount,
    ProcessModal,
    FilterPurchaseOrder,
    PurchaseOrderCheckBox,
    Pagination,
    ViewPurchaseOrder,
    StageOrder,
    ActivityLog,
    ApproveModal,
    RejectOrderItem,
  },

  data() {
    return {
      isBusy: false,
      isBusyModal: false,
      activeSubTab: "salesOrder",
      order: {},
      selectedPurchaseOrders: [],
      selectedPurchaseOrder: [],
      exportAllLoading: false,
      exportSelectedLoading: false,
      activeTab: "sales",
      showDropdown: null,
      isModalVisible: false,
      PurchaseOrderType: null,
      PurchaseOrder: {},
      newOrders: [],
      aOrder: {},
      balance: "",
      originalBodyOverflow: '',
    };
  },

  created() {
    if (!this.hasPermission("Sales_Order_View")) {
      this.$router.push("/restricted");
    }
  },

  computed: {
    ...mapGetters(["purchaseOrders"]),
    loading() {
      return this.$store.state.loading;
    },
    user() {
      return this.$store.state.currentUser;
    },
    filter() {
      return this.$store.state.filter;
    },
    dates() {
      return this.$store.state.dates;
    },
    getOrders() {
      let pur = this.purchaseOrders;
      let items = pur.purchaseOrders || [];
      if (items.length > 0) {
        this.modifyPurchaseOrder();
        return true;
      }
      return false;
    },
    purchaseOrderType() {
      return this.user.isSalesUser ? "salesforce" : "enterprise";
    },
  },

  methods: {
    ...mapActions(["getPurchaseOrder", "setPurchaseOrderPage", "resetPurchaseOrdersPageNumber"]),

    getPurchaseOrder() {
      let type = this.user.isSalesUser ? "salesforce" : "enterprise";
      this.$store.dispatch("getPurchaseOrder", type);
    },
    async viewPurchaseOrder(order, type) {
      let url = this.user.isSalesUser ? "/PurchaseOrders/salesforce" : "/PurchaseOrders/enterprise";
      try {
        this.selectedPurchaseOrder = order;
        this.name = this.selectedPurchaseOrder.name;
        this.code = this.selectedPurchaseOrder.code;
        this.active = this.selectedPurchaseOrder.active;
        this.PurchaseOrderType = type;
        const res = await this.$http.get(`${url}/getList?purchaseOrderNumber=${order.orderNumber}`);
        const data = await res.json();
        if (data.data && data.data.length > 0) {
          this.PurchaseOrder = data.data[0];
          this.isEditMode = true;
        }
        this.isModalVisible = true;
        this.originalBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        await this.getDistributorCreditInformation();
      } catch (err) { }
    },
    async getDistributorCreditInformation() {
      const accountId = this.selectedPurchaseOrder.parent.id;
      const url = "/Accounts/getDistributorCreditInformation";
      if (accountId && accountId != undefined) {
        try {
          const res = await this.$http.get(`${url}/${accountId}`);
          const data = await res.json();
          if (data) {
            this.balance = data.exposureAmount;
          }
        } catch (err) {
          console.error('Error fetching distributor account balance:', err);
        }
      }
    },
    closeModal() {
      this.isModalVisible = false;
      document.body.style.overflow = this.originalBodyOverflow;
      this.activeSubTab = "salesOrder";
      this.balance = "";
      this.getPurchaseOrder();
    },

    refreshOrder() {
      this.getPurchaseOrder();
    },

    async confirmApproveOrder(order, type) {
      this.selectedPurchaseOrder = order;
      this.name = this.selectedPurchaseOrder.name;
      this.code = this.selectedPurchaseOrder.code;
      this.active = this.selectedPurchaseOrder.active;
      this.PurchaseOrderType = type;
      let orderm = this.newOrders.find((v) => v.id == order.id) || {};
      this.PurchaseOrder = order;
      $("#mod-approve").modal("show");
    },

    async rejectOrder(order, type) {
      this.selectedPurchaseOrder = order;
      this.name = this.selectedPurchaseOrder.name;
      this.code = this.selectedPurchaseOrder.code;
      this.active = this.selectedPurchaseOrder.active;
      this.PurchaseOrderType = type;
      let orderm = this.newOrders.find((v) => v.id == order.id) || {};
      this.PurchaseOrder = order;
      $("#mod-reject").modal("show");
    },

    getStatus(status) {
      return status ? status.toLowerCase() : "";
    },

    switchSubTab(subTab) {
      this.activeSubTab = subTab;
    },

    onCompleteHideStage() { },

    async modifyPurchaseOrder() { },

    setDate(date) {
      this.$store.commit("setDate", date);
    },

    toggleDropdown(userId) {
      this.showDropdown = this.showDropdown === userId ? null : userId;
    },

    toggleEditMode(type) {
      this.PurchaseOrderType = type;
    },
    openModal() {
      this.isModalVisible = true;
      this.originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },

    viewFilter() {
      this.$store.dispatch("resetPurchaseOrdersPageNumber");
      $("#mod-purchase-order-filter").modal("show");
    },

    startProcess(order) {
      if (order.status === "confirmed") {
        this.$router.push(`/sales-order/${order.id}/process`);
      } else if (order.status === "submitted") {
        this.order = order;
        $("#mod-process").modal("show");
      }
    },

    onPurchaseAddHandler(value) {
      this.selectedPurchaseOrders.push(value);
    },

    onPurchaseRemoveHandler(value) {
      this.selectedPurchaseOrders = this.selectedPurchaseOrders.filter((x) => x != value);
    },

    switchTab(tab) {
      this.activeTab = tab;
    },
    onFilterHandler(dates) {
      if (dates) this.setDate(dates);
      this.$store.dispatch("resetPurchaseOrdersPageNumber");
      this.getPurchaseOrder();
      $("#mod-purchase-order-filter").modal("hide");
    },
    async downloadAll() {
      this.isBusy = true;
      this.exportAllLoading = true;
      try {
        const response = await this.$http.get(
          `/PurchaseOrders/download?CustomerName=${encodeURIComponent(this.filter.customerName)}&StartDate=${this.dates.startDate}%2000:00:00&EndDate=${this.dates.endDate}%2023:59:59`,
          { responseType: "arraybuffer" }
        );
        this.prepareDownload(response);
        this.isBusy = false;
        this.exportAllLoading = false;
      } catch (error) {
        console.error("Download error:", error);
        this.isBusy = false;
        this.exportAllLoading = false;
      }
    },
    prepareDownload(response) {
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "SalesOrder");
      document.body.appendChild(link);
      link.click();
      this.getPurchaseOrder();
    },
    async downloadSelected() {
      this.isBusy = true;
      this.exportSelectedLoading = true;
      try {
        const response = await this.$http.post(
          "/PurchaseOrders/download/selected",
          this.selectedPurchaseOrders,
          { responseType: "arraybuffer" }
        );
        this.prepareDownload(response);
        this.isBusy = false;
        this.exportSelectedLoading = false;
      } catch (error) {
        this.isBusy = false;
        this.exportSelectedLoading = false;
      }
    },

    visibleActions(order) {
      const actions = [
        {
          label: "View",
          onClick: () => this.viewPurchaseOrder(order, "view"),
          condition: this.hasPermission("Sales_Order_View"),
        },
        {
          label: "Edit",
          onClick: () => this.viewPurchaseOrder(order, "edit"),
          condition:
            order.status.toLowerCase() === "submitted" && this.hasPermission("Sales_Order_Update"),
        },
        {
          label: "Reject",
          onClick: () => this.rejectOrder(order),
          condition:
            order.status.toLowerCase() === "submitted" && this.hasPermission("Sales_Order_Process"),
        },
        {
          label: "Approve",
          onClick: () => this.confirmApproveOrder(order, ""),
          condition:
            order.status.toLowerCase() === "submitted" && this.hasPermission("Sales_Order_Process"),
        },
      ];
      return actions.filter((action) => action.condition !== false);
    },

    formatDate(date) {
      if (date) return moment(date).format("lll");
      else return "";
    },

    onComplete() {
      this.getPurchaseOrder();
      this.$router.push(`/sales-order/${this.order.id}/process`);
    },

    prev() {
      if (this.purchaseOrders.hasPrev) {
        this.$store.dispatch("setPurchaseOrderPage", this.purchaseOrders.pageNumber - 1);
        this.getPurchaseOrder();
      }
    },

    next() {
      if (this.purchaseOrders.hasNext) {
        this.$store.dispatch("setPurchaseOrderPage", this.purchaseOrders.pageNumber + 1);
        this.getPurchaseOrder();
      }
    },

    gotoPage(page) {
      this.$store.dispatch("setPurchaseOrderPage", page);
      this.getPurchaseOrder();
    },

    changeLimit(limit) {
      this.$store.commit("resetPurchaseOrdersPage", { pageSize: limit });
      this.$store.dispatch("resetPurchaseOrdersPageNumber");
      this.getPurchaseOrder();
    },

    getSapInfo(order) {
      const orderStatus = order.status.toLocaleLowerCase();
      if (orderStatus === "rejected" || orderStatus === "cancelled") {
        return "***";
      }
      if (orderStatus === "submitted" || orderStatus === "draft") {
        return "Awaiting approval";
      }
      return order.sapSalesOrderNumber || "No SAP number";
    },

    getTotal(details) {
      if (details.length > 0) {
        return details.reduce((total, item) => {
          return total + item.quantity * item.price;
        }, 0);
      } else {
        return 0;
      }
    },
  },

  mounted() {
    this.$store.commit("clearFilter");
    this.$store.dispatch("resetPurchaseOrdersPageNumber");
    this.getPurchaseOrder();
  },
};
</script>